import { TechDocPage, TechDocWizardPage } from '../containers/pages';
import { ALLETRA9k_VIDEO_URL, PRODUCT_ID_BAAS } from '../constants';
import { softwareConfig } from './baas9kPagesConfigComm';
import { gettingStarted } from './pageConfigComm';

const physicalInstallPath = '/physical-install/';
const fieldCablePath = `${physicalInstallPath}cable/`;
const fieldUnboxPath = `${physicalInstallPath}unbox/`;

export const pagesConfig = [
  ...gettingStarted(PRODUCT_ID_BAAS),
  {
    path: physicalInstallPath,
    menuText: 'physicalInstallation',
    exact: true,
    redirectTo: fieldUnboxPath,
    submenuItems: [
      {
        path: fieldUnboxPath,
        menuText: 'unbox',
        exact: true,
        component: TechDocPage,
        pageProps: {
          videoUrl: ALLETRA9k_VIDEO_URL.FIELD_UNBOX,
        },
      },
      {
        path: `${physicalInstallPath}rack/`,
        menuText: 'rack',
        exact: true,
        redirectTo: `${physicalInstallPath}rack/1`,
      },
      {
        path: `${physicalInstallPath}rack/:step`,
        exact: true,
        component: TechDocWizardPage,
        pageName: 'rack',
        pageProps: {
          steps: [
            {
              videoUrl: ALLETRA9k_VIDEO_URL.FIELD_INSTALL_STEP1,
            },
            {
              videoUrl: ALLETRA9k_VIDEO_URL.FIELD_INSTALL_STEP2,
            },
            {
              videoUrl: ALLETRA9k_VIDEO_URL.FIELD_INSTALL_STEP3,
            },
            {
              videoUrl: ALLETRA9k_VIDEO_URL.FIELD_INSTALL_STEP4,
            },
          ],
        },
      },
      {
        path: fieldCablePath,
        menuText: 'cable',
        exact: true,
        redirectTo: `${fieldCablePath}1`,
      },
      {
        path: `${fieldCablePath}:step`,
        exact: true,
        component: TechDocWizardPage,
        pageName: 'cable',
        pageProps: {
          steps: [
            {
              videoUrl: ALLETRA9k_VIDEO_URL.FIELD_CABLE_STEP1,
            },
            {
              videoUrl: ALLETRA9k_VIDEO_URL.FIELD_CABLE_STEP2,
            },
            {
              videoUrl: ALLETRA9k_VIDEO_URL.FIELD_CABLE_STEP3,
            },
            {
              videoUrl: ALLETRA9k_VIDEO_URL.FIELD_CABLE_STEP4,
            },
            {
              videoUrl: ALLETRA9k_VIDEO_URL.FIELD_CABLE_STEP5,
            },
          ],
        },
      },
      {
        path: `${physicalInstallPath}powerOn`,
        menuText: 'powerOn',
        exact: true,
        component: TechDocPage,
        pageProps: {
          videoUrl: ALLETRA9k_VIDEO_URL.POWERUPANDINIT_POWER,
        },
      },
    ],
  },
  ...softwareConfig,
];
